import apiClient from '@/services/apiClient';

const BASE = '/operation-drafts';

export const listDrafts = async (moduleKey, operationType) => {
  const res = await apiClient.get(BASE, {
    params: { module_key: moduleKey || undefined, operation_type: operationType || undefined },
  });
  return res.data; // { drafts: [...], total }
};

export const getDraft = async (draftId) => {
  const res = await apiClient.get(`${BASE}/${draftId}`);
  return res.data; // full draft incl. payload
};

export const createDraft = async ({ module_key, operation_type, document_id, document_no, label, bundle_count, payload }) => {
  const res = await apiClient.post(BASE, { module_key, operation_type, document_id, document_no, label, bundle_count, payload });
  return res.data; // { draft_id, existing, bundle_count }
};

export const updateDraft = async (draftId, { label, bundle_count, payload }) => {
  const res = await apiClient.put(`${BASE}/${draftId}`, { label, bundle_count, payload });
  return res.data;
};

export const deleteDraft = async (draftId) => {
  const res = await apiClient.delete(`${BASE}/${draftId}`);
  return res.data;
};
